import React from 'react';
import { FormField } from 'components/FormField/FormField';
import { PAutoComplete } from 'components/prime/PAutoComplete/PAutoComplete';
import { useObservableState } from 'observable-hooks';
import { useCodeframesModalBLoC } from '../../CodeframesModal.bloc';

export const CodeframesModalCustomer: React.FC = () => {
  const { $customers, form, isEditCodeframe, getCustomers } = useCodeframesModalBLoC();
  const customers = useObservableState($customers, []);

  return (
    <FormField
      form={form}
      controller={{
        name: 'customer',
        rules: {
          required: 'Customer is required',
        },
      }}
      label="Customer"
    >
      {({ field, fieldState }) => (
        <PAutoComplete
          {...field}
          value={field.value && customers ? customers.find((p) => p.id === field.value) || field.value : null}
          completeMethod={(e) => getCustomers(e.query)}
          field="name"
          suggestions={customers}
          placeholder="Select a customer"
          dropdown
          delay={250}
          forceSelection
          invalid={fieldState.invalid}
          disabled={isEditCodeframe}
        />
      )}
    </FormField>
  );
};
